<template>
  <div id="app">
    <el-container>
      <el-header>

        <navList></navList>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div>
          <div class="footer-mes">Copyright © 2023 汉卓信息技术（上海）有限公司 All rights reserved . 备案：
            <a target="_blank"
               href="https://beian.miit.gov.cn">
              沪ICP备18018924号
            </a>
          </div>

          <div style="width:300px;margin:0 auto; padding:20px 0;">
            <a target="_blank"
               href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402008328"
               style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img src="http://www.hzinfor.cn/uploadFiles/uploadImgs/20230818/98bcd3bd5cc14dc1a8710499335560d1.png"
                   style="float:left;">
              <div style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;">
                沪公网安备 31011402008328号</div>
            </a>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import navList from './views/pc-nav-bar.vue';
export default {
  components: { navList },
  data() {
    return {
      router: true,
      defaultActive: '/',
      isShow: false,
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
.item-list-wrap {
  position: absolute;
  top: 80px;
  right: 0;
  left: 0;
  z-index: 99;
  box-sizing: content-box;
  // display: none;
  min-width: 1440px;
  overflow: hidden;
  background: #fff;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.16);
  // opacity: 0;
  transition: all 0.3s;
}
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  border-top: 1px solid #dedede;
  padding: 40px;
  background: #f2f2f2;
  .footer-mes {
    text-align: center;
  }
}
</style>
